import Api from "../../Services/index";

export const companyData = {
  namespaced: true,
  state: {
    codNrbeEn: "",
    supplierId: "",
    token: null,
  },
  getters: {
    IS_AUTHENTICATED(state) {
      return state.token == null ? false : true;
    },
  },
  mutations: {
    changeSupplierId(state, payload) {
      state.supplierId =  payload
    },

    token(state, payload) {
      state.token =  payload;
    },
    SET_TOKEN(state, payload) {
      state.token = payload;
    },
  },
  actions: {

    async Company_data({ commit }, payload) {     
      try {

        let { data } = await Api.post('/proveedores/validacion', payload)
        commit('SET_TOKEN', data.token)
        sessionStorage.setItem("token", data.response.token)
        Api.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");
        return data
      } catch (error) {
        console.log(error)
        return Promise.reject(error)

      }
    },


  },
}